export const KEYCODE_ARROW_DOWN = 40
export const KEYCODE_ARROW_RIGHT = 39
export const KEYCODE_ARROW_UP = 38
export const KEYCODE_ARROW_LEFT = 37
export const KEYCODE_SPACE = 32
export const KEYCODE_ENTER = 13
